import * as React from 'react'
import { View, ViewStyle } from 'react-native'
import { Color, colors, MaxWidth, maxWidths, radii, Radius } from './theme/index'
import { spacing, SpacingSize } from './types'

interface BoxProps {
	children: React.ReactNode
	padding?: SpacingSize
	paddingX?: SpacingSize
	paddingY?: SpacingSize
	margin?: SpacingSize | 'auto'
	marginX?: SpacingSize | 'auto'
	marginY?: SpacingSize | 'auto'
	background?: Color
	borderRadius?: Radius
	maxWidth?: MaxWidth
	display?: 'flex' | 'none'
	flex?: number
	flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
	flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
	alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline'
	justifyContent?:
		| 'flex-start'
		| 'flex-end'
		| 'center'
		| 'space-between'
		| 'space-around'
		| 'space-evenly'
	width?: string
	style?: ViewStyle | ViewStyle[]
}

export function Box({
	children,
	padding,
	paddingX,
	paddingY,
	margin,
	marginX,
	marginY,
	background = 'transparent',
	borderRadius = 'none',
	maxWidth = 'none',
	display = 'flex',
	flex,
	flexDirection,
	flexWrap,
	alignItems,
	justifyContent,
	width = '100%',
	style,
}: BoxProps) {
	const boxStyle: ViewStyle = {
		display,
		flex,
		flexDirection,
		flexWrap,
		alignItems,
		justifyContent,
		backgroundColor: colors[background],
		borderRadius: radii[borderRadius],
		maxWidth: maxWidth === 'none' ? undefined : maxWidths[maxWidth],
		alignSelf: maxWidth === 'none' ? undefined : 'center',
		width,
		...(padding && {
			padding: spacing[padding],
		}),
		...(paddingX && {
			paddingHorizontal: spacing[paddingX],
		}),
		...(paddingY && {
			paddingVertical: spacing[paddingY],
		}),
		...(margin && {
			margin: margin === 'auto' ? 'auto' : spacing[margin],
		}),
		...(marginX && {
			marginHorizontal: marginX === 'auto' ? 'auto' : spacing[marginX],
		}),
		...(marginY && {
			marginVertical: marginY === 'auto' ? 'auto' : spacing[marginY],
		}),
		...(Array.isArray(style) ? Object.assign({}, ...style) : style),
	}

	return <View style={boxStyle}>{children}</View>
}
